module.exports = __webpack_public_path__ + "static/media/FleetLocate_LoginBanners_FlexBatteryTracker.eb07241a.jpg";